import React, { useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import toast, { Toaster } from "react-hot-toast";

const EmailCampaign = () => {
  const cookies = new Cookies();
  const token = cookies.get("authToken");

  const [formData, setFormData] = useState({
    subject: "",
    body: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    // ✅ Prevent multiple clicks
    if (loading) return;

    // ✅ Validation
    if (!formData.subject.trim() || !formData.body.trim()) {
      toast.error("Please fill all fields");
      return;
    }

    try {
      setLoading(true);

      await axios.post(
        "https://clevdoc-legal-cms-b25ce73f594e.herokuapp.com/campaign/email-service",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "module-id": "notification_service",
          },
        }
      );

      // ✅ Clear form after success
      setFormData({
        subject: "",
        body: "",
      });

      // ✅ Success toast
      toast.success("Email campaign sent successfully 🚀");

    } catch (err) {
      console.error(err);

      toast.error(
        err?.response?.data?.message || "Campaign failed ❌"
      );
    } finally {
      // ✅ Enable button again
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen md:ml-64 mt-28 bg-gray-100 p-4 sm:p-6">

      {/* Toast Container */}
      <Toaster position="top-right" />

      {/* Header */}
      <div className="mb-6">
        <h1 className="text-xl sm:text-2xl font-semibold text-gray-800">
          Email Campaign
        </h1>
        <p className="text-sm text-gray-500">
          Send bulk emails to all users
        </p>
      </div>

      {/* Card */}
      <div className="bg-white rounded-xl shadow-sm p-6 max-w-3xl">

        {/* Subject */}
        <div className="mb-4">
          <label className="text-sm text-gray-600">Subject</label>
          <input
            type="text"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Enter email subject"
            className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Body */}
        <div className="mb-4">
          <label className="text-sm text-gray-600">Message</label>
          <textarea
            name="body"
            value={formData.body}
            onChange={handleChange}
            rows="6"
            placeholder="Enter email content..."
            className="w-full border border-gray-300 rounded-lg px-3 py-2 mt-1 focus:ring-2 focus:ring-blue-500 resize-none"
          />
        </div>

        {/* Button */}
        <button
          onClick={handleSubmit}
          disabled={loading}
          className={`px-6 py-2 rounded-lg text-white text-sm transition ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? (
            <span className="flex items-center gap-2">
              <span className="animate-spin h-4 w-4 border-2 border-white border-t-transparent rounded-full"></span>
              Sending...
            </span>
          ) : (
            "Send Email Campaign"
          )}
        </button>

      </div>
    </div>
  );
};

export default EmailCampaign;